import React from "react";

export const svgOptions = [
	{
		label: "Notification",
		value: "notification",
	},
	{
		label: "Account Circle",
		value: "account_circle",
	},
	{
		label: "Book Ribbon",
		value: "book_ribbon",
	},
	{
		label: "Bookmark",
		value: "bookmark",
	},
	{
		label: "Campaign",
		value: "campaign",
	},
	{
		label: "Chat",
		value: "chat",
	},
	{
		label: "Delete",
		value: "delete",
	},
	{
		label: "Pencil Icon",
		value: "edit_pencil",
	},
	{
		label: "Favourite",
		value: "favourite",
	},
	{
		label: "Filter",
		value: "filter",
	},
	{
		label: "Feature Request",
		value: "feature_request",
	},
	{
		label: "Custom Navigation",
		value: "custom_navigation",
	},
	{
		label: "Add Box",
		value: "add_box",
	},
	{
		label: "Check Circle",
		value: "check_circle",
	},
	{
		label: "Help",
		value: "help",
	},
	{
		label: "Label",
		value: "label",
	},
	{
		label: "Stack",
		value: "stack",
	},
	{
		label: "Stacks",
		value: "stacks",
	},
	{
		label: "Sticky Note",
		value: "sticky_note",
	},
	{
		label: "Tab",
		value: "tab",
	},
	{
		label: "View Cozy",
		value: "view_cozy",
	},
	{
		label: "Timeline",
		value: "timeline",
	},
    {
		label: "Pencil Edit",
		value: "pencil-edit",
	},
	// {
	// 	label: "FullScreen",
	// 	value: "fullScreen",
	// },
	// {
	// 	label: "Help Desk",
	// 	value: "helpDesk",
	// },
	// {
	// 	label: "Language",
	// 	value: "language",
	// },
];
